// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3M85a","col":"Table_col__3LYAR","fulfillmentStatus":"Table_fulfillmentStatus__3w93I","emailCol":"Table_emailCol__3PmxG"};